import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { SocialPostDetailsComponent } from '../social-post-details/social-post-details.component';
@Component({
  imports: [SocialPostDetailsComponent],
  selector: 'app-instagram-reel-details',
  templateUrl: './instagram-reel-details.component.html',
})
export class InstagramReelDetailsComponent extends DeliverableAnalyticsContentDirective {}
